export const url =
    (process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_SERVER_ENDPOINT_PROD
        : process.env.REACT_APP_SERVER_ENDPOINT_DEV) || '';

export const imgUrl =
  process.env.NODE_ENV === 'production' ? process.env.REACT_APP_IMAGE_ENDPOINT_PROD : process.env.REACT_APP_IMAGE_ENDPOINT_DEV;

export const attachmentUrl = process.env.REACT_APP_ATTACHMENT_ENDPOINT;

export const graphQLEndpoint = `${url}/graphql`;
export const imageUrl = `${imgUrl}`;
export const debounceRate = 80;

export const noImageUrl =
    'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/480px-No_image_available.svg.png';



// WEBPACK FOOTER //
// ./src/config/config.ts